<div
  class="circle enabled"
  nbTooltip="Original Value: {{ value }}"
  *ngIf="overrideValue"
></div>
<div
  class="circle disabled"
  nbTooltip="Not Overridden"
  *ngIf="!overrideValue"
></div>
